(function () {
    'use strict';

    angular
        .module('jcsfApp')
        .factory('studentsService', studentsService);

    studentsService.$inject = ['$http', '$filter', 'modelTransformer', 'messaging', 'events', 'Student', 'FireHour', 'NonPublicHour', 'StudentHour', 'authService'];

    function studentsService($http, $filter, modelTransformer, messaging, events, Student, FireHour, NonPublicHour, StudentHour, authService) {
        var baseUrl = '/api/Student/';
        var students = [];
        var dId = 0;
        var student = {};
        var service = {
            init: init
        };

        service.isUnique = isUnique;
        messaging.subscribe(events.message._GET_STUDENT_RESOURCES_LIST_, getStudentResources);
        messaging.subscribe(events.message._GET_STUDENT_LIST_, getStudents);
        messaging.subscribe(events.message._GET_STUDENT_DELETED_LIST_, getDeletedStudents);
        messaging.subscribe(events.message._GET_STUDENT_FULL_LIST_, getStudentsAll);
        messaging.subscribe(events.message._DELETE_STUDENT_, deleteStudent);
        messaging.subscribe(events.message._GET_STUDENT_, getStudent);
        messaging.subscribe(events.message._SAVE_STUDENT_, saveStudent);
        messaging.subscribe(events.message._SAVE_FIRE_HOUR_, saveFireHour);
        messaging.subscribe(events.message._DELETE_FIRE_HOUR_, deleteFireHour);
        messaging.subscribe(events.message._SAVE_STUDENT_HOUR_, saveStudentHour);
        messaging.subscribe(events.message._DELETE_STUDENT_HOUR_, deleteStudentHour);
        messaging.subscribe(events.message._CHECK_STUDENT_EMAIL_EXIST_, checkStudentEmailExists);
        messaging.subscribe(events.message._MAIL_NOTIFICATION_, sendmailNotification);

        return service;
        function init() {
            students = [];
            student = {};
        }
        function isUnique(id, prop, value) {
            if (!id) id = 0;
            return $http.get(baseUrl + 'checkUnique/' + id + '/' +
              prop  + '/' + escape(value)).then(
                function (results) {
                    return results.data;
                });
        }
        function getStudents(clear, center) {
            if (clear === true) {
                students = [];
            }

            messaging.publish(events.message._SERVER_REQUEST_STARTED_);
            var url = 'GetList/' + center;
            $http.get(baseUrl + url)
                .then(getStudentsSuccessHandler, getStudentsErrorHandler);

        }
        function getDeletedStudents(clear,center, searchTerm) {
            if (clear === true) {
                students = [];
            }

            messaging.publish(events.message._SERVER_REQUEST_STARTED_);
            var url = 'GetDeletedStudentList/' + center +'/' + searchTerm;

            $http.get(baseUrl + url)
                .then(getDeletedStudentsSuccessHandler, getDeletedStudentsErrorHandler);

        }
        function getStudentsAll(clear, name) {
            if (clear === true) {
                students = [];
            }
            messaging.publish(events.message._SERVER_REQUEST_STARTED_);
            var url = 'GetFullList/' + name;

            $http.get(baseUrl + url)
                .then(getStudentsSuccessHandler, getStudentsErrorHandler);

        }
        function getStudentResources() {
            messaging.publish(events.message._SERVER_REQUEST_STARTED_);
            var url = 'GetResources/';
            $http.get(baseUrl + url)
                .then(getStudentResourcesSuccessHandler, getStudentResourcesErrorHandler);
        }
        function getStudent(id, ctr) {

            dId = id;
            messaging.publish(events.message._SERVER_REQUEST_STARTED_);

            if (ctr) {
                $http.get(baseUrl + 'Get/' + dId + "/" + ctr)
                    .then(getStudentSuccessHandler, getStudentErrorHandler);
            } else {
                $http.get(baseUrl + 'Get/' + dId  )
                    .then(getStudentSuccessHandler, getStudentErrorHandler);
            }

        }
        function checkStudentEmailExists(id) {
            messaging.publish(events.message._SERVER_REQUEST_STARTED_);
            var data = { PersonalEmailAddress: id };
            $http.post(baseUrl + 'CheckEmailExists/', data)
                .then(checkStudentEmailExistsSuccessHandler, checkStudentEmailExistsErrorHandler);
        }



        function deleteStudent(src) {
            messaging.publish(events.message._SERVER_REQUEST_STARTED_);
            $http.post(baseUrl + 'deleteStudent/', src)
                .then(deleteStudentSuccessHandler, deleteStudentErrorHandler);
        }
        function deleteStudentSuccessHandler(results) {

            if (results) {
                var id = angular.toJson(results.data.StudentId);
                var ix = -1;
                var match = $filter('filter')(students, function (p) {
                    return Number(p.StudentId) === Number(id);
                })[0];
                if (match) {
                    ix = students.indexOf(match);
                }
                if (ix >= 0) {
                    students.splice(ix, 1);
                    //messaging.publish(events.message._STUDENT_LIST_UPDATED_, [students]); //this will FAIL, not implemented?
                }
                messaging.publish(events.message._DELETE_STUDENT_COMPLETE_, [id]);
                messaging.publish(events.message._SERVER_REQUEST_ENDED_);
            } else {
                deleteStudentErrorHandler({ data: { error_description: 'No Records Deleted' } });
            }
        }
        function deleteStudentErrorHandler(results) {
            messaging.publish(events.message._DELETE_STUDENT_FAILED_);
            messaging.publish(events.message._ADD_ERROR_MESSAGE_,
                ['Unable to Delete Student from the server ' + results.data.error_description, 'alert-danger']);
            messaging.publish(events.message._SERVER_REQUEST_ENDED_);
        }


        function getDeletedStudentsSuccessHandler(results) {
            if (results.data && results.data.length) {
                var result = [];
                // students = [];
                angular.forEach(results.data, function (d) {
                    var dr = modelTransformer.transform(d, Student);
                    result.push(dr);
                    // students.push(dr);
                });
                //  students = result;
                messaging.publish(events.message._GET_STUDENT_DELETED_LIST_COMPLETE_, [result]);
                messaging.publish(events.message._SERVER_REQUEST_ENDED_);

            } else {
                getStudentsErrorHandler({ data: { error_description: 'No Records Returned' } });
            }
        }
        function getDeletedStudentsErrorHandler(results) {
            messaging.publish(events.message._GET_STUDENT_DELETED_LIST_FAILED);
            messaging.publish(events.message._ADD_ERROR_MESSAGE_,
                ['Unable to get Deleted Student List', 'alert-danger']);
            messaging.publish(events.message._SERVER_REQUEST_ENDED_);
        }


        function deleteFireHour(id) {
            messaging.publish(events.message._SERVER_REQUEST_STARTED_);
            $http.post(baseUrl + 'deleteFireHour/' + id)
                .then(deleteFireHourSuccessHandler, deleteFireHourErrorHandler);
        }
        function deleteStudentHour(id) {
            messaging.publish(events.message._SERVER_REQUEST_STARTED_);
            $http.post(baseUrl + 'deleteStudentHour/' + id)
                .then(deleteStudentHourSuccessHandler, deleteStudentHourErrorHandler);
        }
        function saveStudent(src) {

            messaging.publish(events.message._SERVER_REQUEST_STARTED_);
            $http.post(baseUrl + 'saveStudent/', src)
                .then(saveStudentSuccessHandler, saveStudentErrorHandler);
        }
        function sendmailNotification(src) {
            //if (recipientName) {
                messaging.publish(events.message._SERVER_REQUEST_STARTED_);

                $http.post(baseUrl + 'mailNotification/' , src)
                    .then(sendmailNotificationSuccessHandler, sendmailNotificationErrorHandler);
            //}
        }
        function saveFireHour(src) {

            messaging.publish(events.message._SERVER_REQUEST_STARTED_);
            $http.post(baseUrl + 'saveFireHour/', src)
                .then(saveFireHourSuccessHandler, saveFireHourErrorHandler);
        }
        function saveStudentHour(src) {

            messaging.publish(events.message._SERVER_REQUEST_STARTED_);
            $http.post(baseUrl + 'saveStudentHour/', src)
                .then(saveStudentHourSuccessHandler, saveStudentHourErrorHandler);
        }

        function getStudentsSuccessHandler(results) {
            if (results.data && results.data.length) {
                var result = [];
                students = [];
                angular.forEach(results.data, function (d) {
                    var dr = modelTransformer.transform(d, Student);
                    result.push(dr);
                    students.push(dr);
                });
                students = result;
                messaging.publish(events.message._GET_STUDENT_LIST_COMPLETE_, [students]);
                messaging.publish(events.message._SERVER_REQUEST_ENDED_);

            } else {
                getStudentsErrorHandler({ data: { error_description: 'No Records Returned' } });
            }
        }
        function checkStudentEmailExistsSuccessHandler(results) {
            messaging.publish(events.message._CHECK_STUDENT_EMAIL_EXIST_COMPLETE_, [results.data]);
            messaging.publish(events.message._SERVER_REQUEST_ENDED_);

        }
        function checkStudentEmailExistsErrorHandler(results) {
            messaging.publish(events.message._CHECK_STUDENT_EMAIL_EXIST_FAILED_, [false]);
            messaging.publish(events.message._SERVER_REQUEST_ENDED_);

        }
        function getStudentSuccessHandler(results) {
            if (results.data) {
                student = updateOrAddStudent(results.data);
                messaging.publish(events.message._GET_STUDENT_COMPLETE_, [student]);
                messaging.publish(events.message._SERVER_REQUEST_ENDED_);
            } else {
                getStudentErrorHandler({ data: { error_description: 'No Records Returned' } });
            }
        }
        function getStudentResourcesSuccessHandler(results) {
            if (results.data) {
                messaging.publish(events.message._GET_STUDENT_RESOURCES_LIST_COMPLETE_, [results.data]);
                messaging.publish(events.message._SERVER_REQUEST_ENDED_);
            } else {
                getStudentErrorHandler({ data: { error_description: 'No Records Returned' } });
            }
        }

        function deleteFireHourSuccessHandler(results) {
            if (results) {
                messaging.publish(events.message._DELETE_FIRE_HOUR_COMPLETE_, [results.data.FireHourId]);
                messaging.publish(events.message._SERVER_REQUEST_ENDED_);
            } else {
                deleteFireHourErrorHandler({ data: { error_description: 'No Records Deleted' } });
            }
        }
        function deleteStudentHourSuccessHandler(results) {
            if (results) {
                messaging.publish(events.message._DELETE_STUDENT_HOUR_COMPLETE_, [results.data.StudentHoursId]);
                messaging.publish(events.message._SERVER_REQUEST_ENDED_);
            } else {
                deleteStudentHourErrorHandler({ data: { error_description: 'No Records Deleted' } });
            }
        }
        function saveStudentSuccessHandler(results) {
            if (results.data) {
                var result = results.data;
                student = updateOrAddStudent(result);
                messaging.publish(events.message._SAVE_STUDENT_COMPLETE_, [student]);
                //messaging.publish(events.message._STUDENT_LIST_UPDATED_, [students]); //this fails, not implemented??
                messaging.publish(events.message._SERVER_REQUEST_ENDED_);
                messaging.publish(events.message._SAVE_SUCCESS_);
                //showalert("#success-alert");
               document.getElementById("success-alert").style.display = "block";


            } else {
                saveStudentErrorHandler({ data: { error_description: 'No Records Saved' } });
            }
        }

        function showalert(sID) {
            $(sID).alert();
            //$(sID).fadeTo(2000, 500).slideUp(500, function () {
            //    $(sID).alert('close');
            //});
        }

        function sendmailNotificationSuccessHandler(results) {
            if (results.data) {

                messaging.publish(events.message._MAIL_NOTIFICATION_COMPLETE_, [results.data]);
                //messaging.publish(events.message._STUDENT_LIST_UPDATED_, [students]); //this fails, not implemented??
                messaging.publish(events.message._SERVER_REQUEST_ENDED_);

            } else {
                sendmailNotificationErrorHandler({ data: { error_description: 'No Records Saved' } });
            }
        }
        function saveFireHourSuccessHandler(results) {
            if (results.data) {
                var result = results.data;
                var fireHour = modelTransformer.transform(result, FireHour);
                messaging.publish(events.message._SAVE_FIRE_HOUR_COMPLETE_, [fireHour]);
                messaging.publish(events.message._SERVER_REQUEST_ENDED_);
                messaging.publish(events.message._SAVE_SUCCESS_);
                $("#success-alert").alert();
                $("#success-alert").fadeTo(2000, 500).slideUp(500, function () {
                    $("#success-alert").alert('close');
                });
            } else {
                saveStudentErrorHandler({ data: { error_description: 'No Records Saved' } });
            }
        }
        function saveStudentHourSuccessHandler(results) {
            if (results.data) {
                var result = results.data;
                var sHour = modelTransformer.transform(result, StudentHour);
                messaging.publish(events.message._SAVE_STUDENT_HOUR_COMPLETE_, [sHour]);
                messaging.publish(events.message._SERVER_REQUEST_ENDED_);
                messaging.publish(events.message._SAVE_SUCCESS_);
                $("#success-alert").alert();
                $("#success-alert").fadeTo(2000, 500).slideUp(500, function () {
                    $("#success-alert").alert('close');
                });
            } else {
                saveStudentErrorHandler({ data: { error_description: 'No Records Saved' } });
            }
        }
        function updateOrAddStudent(result) {
            student = modelTransformer.transform(result, Student);
            return student;
        }

        function getStudentErrorHandler(results) {
            messaging.publish(events.message._GET_STUDENT_FAILED_);
            messaging.publish(events.message._ADD_ERROR_MESSAGE_,
                ['Unable to get Student from the server', 'alert-danger']);
            messaging.publish(events.message._SERVER_REQUEST_ENDED_);
        }

        function getStudentsErrorHandler(results) {
            messaging.publish(events.message._GET_STUDENT_LIST_FAILED);
            messaging.publish(events.message._ADD_ERROR_MESSAGE_,
                ['Unable to get Student List', 'alert-danger']);
            messaging.publish(events.message._SERVER_REQUEST_ENDED_);
        }
        function getStudentResourcesErrorHandler(results) {
            messaging.publish(events.message._GET_STUDENT_RESOURCES_LIST_FAILED_);
            messaging.publish(events.message._ADD_ERROR_MESSAGE_,
                ['Unable to get Student Resources List', 'alert-danger']);
            messaging.publish(events.message._SERVER_REQUEST_ENDED_);
        }

        function deleteFireHourErrorHandler(results) {
            messaging.publish(events.message._DELETE_FIRE_HOUR_FAILED_);
            messaging.publish(events.message._ADD_ERROR_MESSAGE_,
                ['Unable to Delete Fire Hour from the server ' + results.data.error_description, 'alert-danger']);
            messaging.publish(events.message._SERVER_REQUEST_ENDED_);
        }
        function deleteStudentHourErrorHandler(results) {
            messaging.publish(events.message._DELETE_STUDENT_HOUR_FAILED_);
            messaging.publish(events.message._ADD_ERROR_MESSAGE_,
                ['Unable to Delete Student Hour from the server ' + results.data.error_description, 'alert-danger']);
            messaging.publish(events.message._SERVER_REQUEST_ENDED_);
        }
        function saveStudentErrorHandler(results) {
            messaging.publish(events.message._SAVE_STUDENT_FAILED_);
            messaging.publish(events.message._ADD_ERROR_MESSAGE_,
                ['Unable to save Student to the server ' + results.data.error_description, 'alert-danger']);
            messaging.publish(events.message._SERVER_REQUEST_ENDED_);
        }
        function sendmailNotificationErrorHandler(results) {
            messaging.publish(events.message._MAIL_NOTIFICATION_FAILED_);
            messaging.publish(events.message._ADD_ERROR_MESSAGE_,
                ['Unable to send mail notification ' + results.data.error_description, 'alert-danger']);
            messaging.publish(events.message._SERVER_REQUEST_ENDED_);
        }
        function saveFireHourErrorHandler(results) {
            messaging.publish(events.message._SAVE_FIRE_HOUR_FAILED_);
            messaging.publish(events.message._ADD_ERROR_MESSAGE_,
                ['Unable to save Fire HOur to the server ' + results.data.error_description, 'alert-danger']);
            messaging.publish(events.message._SERVER_REQUEST_ENDED_);
        }
        function saveStudentHourErrorHandler(results) {
            messaging.publish(events.message._SAVE_STUDENT_HOUR_FAILED_);
            messaging.publish(events.message._ADD_ERROR_MESSAGE_,
                ['Unable to save Student Hour to the server ' + results.data.error_description, 'alert-danger']);
            messaging.publish(events.message._SERVER_REQUEST_ENDED_);
        }
    }
})();
